window.initFederationFileJs = () => {
    $( document ).ready(function() {
        let selectParentDirectory = $('#parent_directory_select').find('select');
        let isInternalInput = $('#is_internal_checkbox').find('input');
        let selectInstitutionsDiv = $('#institutions_select');
        let nodeSharingOptionsDiv = $('#node_sharing_options');

        let selectIndividualKindergartens = $('#select_individual_kindergartens');
        let numKindergartens = selectIndividualKindergartens.find('input').length;
        let selectAllKindergarten = $('#select_all_kindergarten');
        let selectAllKindergartenInput = selectAllKindergarten.find('input');
        let selectAllKindergartenLabel = $('<span style=\'display: none\'>(+'+numKindergartens+')</span>');
        selectAllKindergarten.find('label').append(selectAllKindergartenLabel);

        let selectIndividualClubs = $('#select_individual_clubs');
        let numClubs = selectIndividualClubs.find('input').length;
        let selectAllClub = $('#select_all_club');
        let selectAllClubInput = selectAllClub.find('input');
        let selectAllClubLabel = $('<span style=\'display: none\'>(+'+numClubs+')</span>');
        selectAllClub.find('label').append(selectAllClubLabel);

        selectAllClubInput.on('change', function(){
            if($(this).is(':checked')){
                selectIndividualClubs.hide();
                selectAllClubLabel.show();
            } else {
                selectIndividualClubs.show();
                selectAllClubLabel.hide();
            }
        });
        selectAllClubInput.trigger('change');

        selectAllKindergartenInput.on('change', function(){
            if($(this).is(':checked')){
                selectIndividualKindergartens.hide();
                selectAllKindergartenLabel.show();
            } else {
                selectIndividualKindergartens.show();
                selectAllKindergartenLabel.hide();
            }
        });
        selectAllKindergartenInput.trigger('change');

        isInternalInput.on('change', function(){
            if($(this).is(':checked')){
                selectInstitutionsDiv.hide();
            } else {
                selectInstitutionsDiv.show();
            }
        });
        isInternalInput.trigger('change');

        selectParentDirectory.change(function(){
            if($(this).val() !== ''){
                nodeSharingOptionsDiv.hide();
            } else {
                nodeSharingOptionsDiv.show();
            }
        });
        selectParentDirectory.trigger('change');
    });
};
